import { Response, apiAbortController } from '@ui/src';
import api from '../../../../api/api';
import { PaymentType } from '../../types';

export const paymentTypesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getExchangePaymentTypes: build.query<Response<PaymentType>, void>({
      query: () => ({
        url: '/v1/payment-categories?all=true',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getPaymentType: build.query<{ data: PaymentType }, string>({
      query: (id: string) => ({
        url: `/v1/payment-categories/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    editPaymentTypeCurrencies: build.mutation<
      { data: PaymentType },
      {
        id: string;
        body: {
          id: string;
          currencies: string[];
        };
      }
    >({
      query: (data) => ({
        url: `/v1/payment-categories/${data.id}`,
        method: 'PUT',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    paymentTypeStatusesBatchUpdate: build.mutation<
      { data: PaymentType[] },
      {
        data: {
          id: string;
          visibleToClients: boolean;
          enabled: boolean;
        }[];
      }
    >({
      query: (data) => ({
        url: '/v1/payment-categories/status',
        method: 'PUT',
        body: {
          data: data.data,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetExchangePaymentTypesQuery,
  useLazyGetPaymentTypeQuery,
  useEditPaymentTypeCurrenciesMutation,
  usePaymentTypeStatusesBatchUpdateMutation,
} = paymentTypesApi;

export const {
  endpoints: {
    getExchangePaymentTypes,
    getPaymentType,
    editPaymentTypeCurrencies,
    paymentTypeStatusesBatchUpdate,
  },
} = paymentTypesApi;
